(function () {
  function init() {
    var banner = document.querySelector('[data-dcb-cookie-banner]');
    if (!banner) return;
    var stored;
    try { stored = localStorage.getItem('dcb_cookie'); } catch (e) { stored = null; }
    if (!stored) banner.hidden = false;

    function set(value) {
      try { localStorage.setItem('dcb_cookie', value); } catch (e) {}
      banner.hidden = true;
    }
    var acceptBtn = banner.querySelector('[data-dcb-cookie-accept]');
    var declineBtn = banner.querySelector('[data-dcb-cookie-decline]');
    if (acceptBtn) acceptBtn.addEventListener('click', function () { set('all'); });
    if (declineBtn) declineBtn.addEventListener('click', function () { set('necessary'); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
